import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import DOMPurify from 'dompurify';
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import TranslateWidget from "../Shared/TranslateWidget/TranslateWidget";
import CreateInvoiceContent from "./CreateInvoiceContent";
import CreateInvoicePayContent from "./CreateInvoicePayContent";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import axios from "axios";
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

import "./CreateInvoice.css";

export default function EditInvoice() {
  const editorRef = useRef(null);

  const childStateRef = useRef();
  const { invoiceId, code } = useParams();
  const [invoicetitle, setinvoicetitle] = useState("1");

  const [contractCount, setContractCount] = useState(1);

  const [contract, setContract] = useState(null);
  const [eventDate, setEventDate] = useState(null);

  const [invoiceitem, setinvoiceitem] = useState(null);

  const [invoicepayments, setinvoicepayments] = useState([]);

  const [paidpayment, setpaidpayment] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [length, setlength] = useState(0);

  const [pagescontent, setPagescontent] = useState([]);
  const [taxperstate, setTaxperstate] = useState(0);
  const [taxstate, settaxstate] = useState(0);

  const [discountperState, setDiscountperState] = useState(0);
  const [discountState, setDiscountState] = useState(0);

  const [purchageorder, setpurchageorder] = useState("");

  const [shareduserdetail, setshareduserdetail] = useState([]);

  const [showpaging, setshowpaging] = useState(false);

  const [paidduePayments, setPaidduePayments] = useState(null);

  const [sharedinvoice, setsharedinvoice] = useState(null);

  const [paymentsucessdetails, setpaymentsucessdetails] = useState(false);

  const handlepaymentsucess = (value) => {
    setpaymentsucessdetails(value);
  };

  const handleNextPage = () => {
    if (currentPage < length) {
      setCurrentPage(currentPage + 1);
    }
  };

  // Handler for the previous button
  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };



  const title = useSelector((state) => state.title.title);

  const [tabs, setTabs] = useState([]);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // what should happen after the initial render
    const buttonid = `v-pills-${contractCount}-tab`;
    const activebutton = document.getElementById(buttonid);
    if (activebutton) {
      activebutton.click();
    }
    //active.setAttribute("data-scroll", <your_value>)
  }, [tabs.length]);

  const totalpayment = () => {
    const Totalpayment = childStateRef.current.getTotalpayment();
    setpaidpayment(Totalpayment);
  };

  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      // const tabTitle = document.querySelector(`#${newTabId}-tab .box-title`);
      // tabTitle.textContent = newTitle;
      // alert("dhirendra");
      setTabs((prevTabs) =>
        prevTabs.map((tab) =>
          tab.id === tabId ? { ...tab, title: newTitle } : tab
        )
      );
    }
  };

  const handleClick = (id) => {
    setTabs((prevTabs) => prevTabs.filter((item) => item.id !== id));
  };

  const handleAddContract = () => {
    const newTabId = `v-pills-${contractCount + 1}`;
    const buttonid = `v-pills-${contractCount + 1}-tab`;
    const newTabContentId = `v-pills-content-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: `<div>
        <h1>${newTabTitle}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 1);
    document.getElementById("offcanvasRight2").classList.remove("show");
    document.getElementById("offcanvasRight2").style.visibility = "hidden";
  };

  const handleSubmit = async () => {
    const servicesstate = childStateRef.current.getMyservices();
    const PaymentsState = childStateRef.current.getPayments();

    const TaxperState = childStateRef.current.getTaxper();
    const TaxState = childStateRef.current.getTax();
    const DiscountperState = childStateRef.current.getDiscountper();
    const DiscountState = childStateRef.current.getDiscount();


    servicesstate.map((tab, i) => {
      if (tab.descp == "") {
        // updatedServices[index].errorprice="Required";
        var descerrro = document.getElementById("desc-" + i).parentElement;
        const small = descerrro.querySelector("small");
        small.innerText = "Error:fill the fileds marked with *";
      }
      if (tab.type == "") {
        // updatedServices[index].errorprice="Required";
        var descerrro = document.getElementById("name-" + i).parentElement;
        const small = descerrro.querySelector("small");
        small.innerText = "Error: fill the fileds marked with *";
      }
    });

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/api/invoice/${invoiceId}`,
        {
          title: title,
          user_id: JSON.parse(localStorage.getItem("user")).user.id,
          taxper: TaxperState,
          tax: TaxState,
          discountper: DiscountperState,
          discount: DiscountState,
          items: servicesstate.map((tab) => ({
            price: tab.price,
            qty: tab.qty,
            unit_option: tab.unit_option,
            itemtotalprice: tab.itemtotalprice,
            type: tab.type,
            descp: tab.descp,
          })),
          pages: tabs.map((tab) => ({
            content: tab.content,
            page_name: tab.title,
          })),
          payments: PaymentsState.map((tab) => ({
            amount: tab.amount,
            dueDate: tab.dueDate,
            paymentId: tab.paymentId || '',
            type: tab.type || '',
            smartdays: tab.smartdays || '',
            timetype: tab.timetype || '',
            smartdirection: tab.smartdirection || '',
            paymenttype: tab.paymenttype || 'equal',
          })),
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Invoice saved successfully!",
      });
      navigate("/invoices");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };
  const getEventDetails = async (id) => {
    try {
      let eventTrackingId = id;

      if (!eventTrackingId) {
        console.warn("⚠️ No eventTrackingId found in localStorage or parameters.");
        return;
      }

      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/event/${eventTrackingId}`);
      setEventDate(response.data?.events?.date);
      return response.data?.events;
    } catch (error) {
      console.error("❌ Failed to fetch event details:", error.message);
    }
  };
  useEffect(() => {
    const fetchContract = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/sharedinvoice/${invoiceId}/${code}`
        );

        // setContractContent(response.data.pages[0].content);
        const invoiceIdTracking = response?.data?.sharedinvoice?.id;
        const eventIdTracking = response?.data?.sharedinvoice?.event_id;
        // Set event date from the shared invoice response (works on public pages)
        if (response.data?.events?.date) {
          setEventDate(response.data.events.date);
        } else {
          getEventDetails(eventIdTracking);
        }
        const userIdFromInvoice = response?.data?.sharedinvoice?.user_id;

        if (userIdFromInvoice) {
          localStorage.setItem("shared_user_id", userIdFromInvoice);
          localStorage.setItem("shared_invoice_id", invoiceIdTracking);
          localStorage.setItem("shared_event_id", eventIdTracking);
        }
        setshareduserdetail(response.data.user);

        // setContract(response.data);
        // count=10;

        // setContractTitle(response.data.title);
        setinvoicetitle(response.data.sharedinvoice.title);

        setpurchageorder(response.data.sharedinvoice.purchageorder);


        setinvoiceitem(response.data.sharedinvoice.invoice_item);

        setsharedinvoice(response.data.sharedinvoice);

        //setinvoicepayments(response.data.invoice_payment);

        setinvoiceitem(JSON.parse(response.data.sharedinvoice.items));

        setinvoicepayments(JSON.parse(response.data.sharedinvoice.payment));



        setpaidpayment(
          JSON.parse(response.data.sharedinvoice.payment)[0].amount
        );

        setPagescontent((prevContent) => [
          ...prevContent,
          {
            type: "invoiceitem",
            content: JSON.parse(response.data.sharedinvoice.items),
          },
        ]);

        JSON.parse(response.data.sharedinvoice.pages).forEach(
          (tabs1, index) => {
            const newTabTitle = tabs1.page_name;

            const evtData = response.data.events || {};
            const newTabContent = (tabs1.content || "")
              .replace(/{Event_Name}/g, evtData.name || "")
              .replace(/{First_Client_First_Name}/g, evtData.cl_firstname || "")
              .replace(/{First_Client_Last_Name}/g, evtData.cl_lastname || "")
              .replace(/{First_Client_Email}/g, evtData.cl_email || "")
              .replace(/{Event_Location}/g, evtData.address || "")
              .replace(/{Event_Date}/g, (() => {
                if (!evtData.date) return "";
                const [year, month, day] = evtData.date.split("-");
                return month && day && year ? `${month}-${day}-${year}` : evtData.date;
              })())
              .replace(
                /{Event_Type}/g,
                evtData.get_event_category?.name || ""
              );

            const newTab = {
              id: `v-pills-${index}`,
              title: newTabTitle,
              content: newTabContent,
            };
            setTabs((tabs) => [...tabs, newTab]);

            setPagescontent((prevContent) => [
              ...prevContent,
              { type: "page", content: newTabContent },
            ]);
          }
        );

        setPagescontent((prevContent) => [
          ...prevContent,
          {
            type: "invoicepayment",
            content: JSON.parse(response.data.sharedinvoice.payment),
          },
        ]);
      } catch (error) {
        console.error("Error fetching contract:", error);
      }
    };
    fetchContract();
  }, []);

  useEffect(() => {

  }, [invoiceitem]);

  useEffect(() => {
    setlength(pagescontent.length - 1);
  }, [pagescontent]);

  const handletax = () => {
    const servicesstate = childStateRef.current.getMyservices();
    const PaymentsState = childStateRef.current.getPayments();
    const TaxperState = childStateRef.current.getTaxper();
    const TaxState = childStateRef.current.getTax();
    const DiscountperState = childStateRef.current.getDiscountper();
    const DiscountState = childStateRef.current.getDiscount();

    setTaxperstate(TaxperState);
    settaxstate(TaxState);
    setDiscountperState(DiscountperState);
    setDiscountState(DiscountState);
  };

  useEffect(() => {
    // Wait until childStateRef is available (after mount)
    if (childStateRef.current) {
      // Access getPayments() safely after ref is assigned
      const payments = childStateRef.current.getPayments();


      setPaidduePayments(payments); // Set payments in state
    }

  }, [childStateRef.current]);

  return (
    <>
      <div className="customer-view-translate-bar bg-light border-bottom">
        <div className="customer-view-translate-bar-inner">
          <TranslateWidget />
        </div>
      </div>
      <div
        className="container-fluid p-3"
        style={{
          display: "flex",
        }}
      >
        {/* Text Editor part */}

        {paymentsucessdetails ? (
          <div
            style={{
              width: "1000px",
              margin: "0 auto",
              minHeight: "80vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className="text-editor px-1 py-1 bg-view-contract fulinvoice"
              style={{
                textAlign: "left",
                height: "auto",
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "60vh",
              }}
            >
              <div className="section_container" style={{ width: "100%" }}>
                <div
                  style={{
                    textAlign: "center",
                    margin: "0 auto",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    width: "100%",
                  }}
                >
                  <div className="py-5" style={{ width: "75%", margin: "0px auto" }}>
                    <div
                      className="logo"
                      style={{ width: "50%", margin: "0px auto" }}
                    >
                      <img
                        src={
                          shareduserdetail.Secondary_Logo
                            ? process.env.REACT_APP_BACKEND_URL +
                            shareduserdetail.Secondary_Logo
                            : null
                        }
                        alt="Secondary Logo Preview"
                        className="mainimgpath "
                        style={{ maxWidth: "200px" }}
                      />
                    </div>

                    <div style={{ fontSize: "26px" }}>
                      <b>All done!</b>
                    </div>

                    <div style={{ textAlign: "center", margin: "10px" }}>
                      Your Payment has been successfully completed. {" "}
                    </div>
                    <div>
                      {" "}
                      <span
                        style={{ textDecoration: "underline", cursor: "pointer" }}
                      ></span>{" "}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            <div style={{ width: "1000px", margin: "0 auto" }}>
              {!showpaging && (
                <>
                  <div className="pagination-controls col-md-12 text-end mb-3">
                    {currentPage > 0 ? (
                      <>
                        <button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 0}
                          className="Nxt"
                        >
                          Previous
                        </button>
                      </>
                    ) : (
                      <></>
                    )}

                    <span>
                      {" "}
                      Page {currentPage + 1} of {length + 1}{" "}
                    </span>

                    {currentPage < length ? (
                      <>
                        <button
                          onClick={handleNextPage}
                          disabled={currentPage === length}
                          className="Nxt"
                        >
                          Next
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}

              <div
                className="text-editor px-1 py-1 bg-view-contract fulinvoice"
                style={{ textAlign: "left", height: 'auto' }}
              >
                {pagescontent.length && (
                  <>
                    {pagescontent[currentPage].type == "invoiceitem" && (
                      <>
                        <CreateInvoiceContent
                          eventDate={eventDate}
                          ref={childStateRef}
                          items={invoiceitem}
                          invoicepayments={invoicepayments}
                          purchageorder={purchageorder}
                          userDetail={shareduserdetail}
                        />
                      </>
                    )}

                    {pagescontent[currentPage].type == "invoicepayment" && (
                      <>
                        {paidduePayments && (
                          <CreateInvoicePayContent
                            paidpayment1={invoicepayments}
                            sharedinvoice={sharedinvoice}
                            paymentstatus={handlepaymentsucess}
                          />
                        )}
                      </>
                    )}

                    {pagescontent[currentPage].type == "page" && (
                      <div class="section_container p-4 mb-2">
                        <div className="row left">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: DOMPurify.sanitize(pagescontent[currentPage].content),
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>

              {/* Contract Right Area */}

              {!showpaging && (
                <>
                  <div className="pagination-controls col-md-12 text-end">
                    {currentPage > 0 ? (
                      <>
                        <button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 0}
                          className="Nxt"
                        >
                          Previous
                        </button>
                      </>
                    ) : (
                      <></>
                    )}

                    <span>
                      {" "}
                      Page {currentPage + 1} of {length + 1}{" "}
                    </span>

                    {currentPage < length ? (
                      <>
                        <button
                          onClick={handleNextPage}
                          disabled={currentPage === length}
                          className="Nxt"
                        >
                          Next
                        </button>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </>
  );
}
